var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-select',_vm._b({attrs:{"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }}},'b-select',_vm.$attrs,false),[(_vm.allowEmpty)?_c('option',{domProps:{"value":{
      name: null,
      details: {
        theoretical: null,
        department: null,
        type: null
      }
    }}},[_vm._v("\n        Любая дисциплина\n    ")]):_vm._e(),_vm._v(" "),(_vm.restrict == null || _vm.restrict == 'main')?[_c('option',{domProps:{"value":{
            name: 'main',
            details: {
                theoretical: true
            }
        }}},[_vm._v("\n            Основная теоретическая\n        ")]),_vm._v(" "),_c('option',{domProps:{"value":{
            name: 'main',
            details: {
                theoretical: false
            }
        }}},[_vm._v("\n            Основная практическая\n        ")])]:_vm._e(),_vm._v(" "),(_vm.restrict == null || _vm.restrict == 'department')?_c('optgroup',{attrs:{"label":"Дисциплина кафедры"}},[(_vm.allowEmpty)?_c('option',{domProps:{"value":{ name: 'department' }}},[_vm._v("\n            Любая кафедра\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.departments),function(department){return _c('option',{key:department.id,domProps:{"value":{
                name: 'department',
                details: {
                    department: {
                        id: department.id
                    }
                }
            }}},[_vm._v("\n            "+_vm._s(department.name)+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.restrict == null || _vm.restrict == 'generic')?_c('optgroup',{attrs:{"label":"Другое"}},[_c('option',{domProps:{"value":{
            name: 'generic',
            details: {
                type: 'practice'
            }
        }}},[_vm._v("\n            Практика\n        ")]),_vm._v(" "),_c('option',{domProps:{"value":{
            name: 'generic',
            details: {
                type: 'attestation'
            }
        }}},[_vm._v("\n            Итоговая аттестация\n        ")])]):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-753ff515","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/models/subject/components/SubjectTypeSelect.vue
// module id = suco
// module chunks = 1